// extracted by mini-css-extract-plugin
export default {"overlay":"feedback-modal_overlay__-Ri9R","content":"feedback-modal_content__v-akW","header":"feedback-modal_header__DVYqZ","body":"feedback-modal_body__fvhY4"};